import React from "react";
import "./ForgotPasswordModal.css";

const ForgotPasswordModal = ({
  isOpen,
  onClose,
  onSubmit,
  formData,
  onChange,
  isLoading,
  showSuccess,
}) => {
  if (!isOpen) return null;

  return (
    <div className="forgot-password-modal-overlay" onClick={onClose}>
      <div
        className="forgot-password-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Forgot Password</h3>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          {!showSuccess ? (
            <>
              <p>
                Enter your work email address to receive a password reset link.
              </p>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  onSubmit();
                }}
              >
                <div className="form-group">
                  <label htmlFor="workEmail">Work Email</label>
                  <input
                    type="email"
                    id="workEmail"
                    name="workEmail"
                    value={formData.workEmail}
                    onChange={onChange}
                    placeholder="Enter your work email"
                    required
                    disabled={isLoading}
                  />
                </div>

                <div className="modal-actions">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onClose}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading || !formData.workEmail.trim()}
                  >
                    {isLoading ? "Sending..." : "Send Reset Link"}
                  </button>
                </div>
              </form>
            </>
          ) : (
            <div className="success-message">
              <div className="success-icon">✓</div>
              <h4>Reset Link Sent!</h4>
              <p>
                Please check your work email for instructions to reset your
                password.
              </p>
              <button className="btn btn-primary" onClick={onClose}>
                Close
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
